import type { OrganizationSiteProfileResponse } from 'types/organization-site';

import * as stringUtil from '../../utils/string-util';

import { Api } from './api';
import endpoints from './endpoints';

export default class SitesApi {
  private api: Api;

  constructor(api: Api = new Api()) {
    this.api = api;
  }

  async getOrganizationProfileByDomain(
    domain: string
  ): Promise<OrganizationSiteProfileResponse> {
    return await this.api.fetch.get(
      stringUtil.replaceUrlParams(
        endpoints.sites.organizationProfile.getByDomain,
        {
          domain,
        }
      )
    );
  }

  async getOrganizationProfileBySubdomain(
    subdomain: string
  ): Promise<OrganizationSiteProfileResponse> {
    return await this.api.fetch.get(
      stringUtil.replaceUrlParams(
        endpoints.sites.organizationProfile.getBySubdomain,
        {
          subdomain,
        }
      )
    );
  }
}
